import React from 'react';
import { useSelector } from 'react-redux';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { APP_ERROR_DIMENSIONS, errorMetrics } from '@utils/dimension/appDimensionHelper';
import { allDimensionsListSelector } from '@src/store/common/dimensionList/selectors';
import StaticTableWidget from './StaticTable';

function AppErrorDimensionWidget() {
  const selectedMetric = useSelector(selectedMetricSelector);
  if (!errorMetrics.includes(selectedMetric)) {
    return null;
  }
  return (
    <>
      {APP_ERROR_DIMENSIONS.map((options) => {
        return (
          <DimensionTableWidget
            header={options.header}
            dimension={options.dimension}
            key={options.dimension}
          />
        );
      })}
    </>
  );
}

const DimensionTableWidget: React.FC<{ header: string; dimension: string }> = (props) => {
  const { header, dimension } = props;

  const supportedDimension = useSelector(allDimensionsListSelector) as any[];
  // disable drill down if this dimension is not in supported dimension list
  const disableDrilldown = supportedDimension.every((it) => it.groupBy !== dimension);

  return (
    <StaticTableWidget header={header} dimension={dimension} disableDrilldown={disableDrilldown} />
  );
};

export default AppErrorDimensionWidget;
